import React, { FocusEventHandler, useContext, useEffect, useState } from 'react';

import { useParams } from "react-router-dom";
import { AuthContext } from "../../../../config/AuthContext";
import { Button, FloatButton, Form, InputNumber, Spin, Table, Tag, TreeSelect, Card, Row, Col, Typography, Select, Modal, Input, Popconfirm, Tooltip } from "antd";
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import { PostProjecteConfiguracio } from "../../../../dao/abp/PostProjecteConfiguracio";
import { BiRefresh, BiCog, BiTrash, BiPlus, BiEdit } from "react-icons/bi";
import { GetProjecteId } from "../../../../dao/abp/GetProjecteId";
import { GetAulaIdConfiguracio } from "../../../../dao/GetAulaIdConfiguracio";
import { GetProjecteIdConfiguracio } from "../../../../dao/abp/GetProjecteIdConfiguracio";
import TextArea from "antd/es/input/TextArea";
import { PostProjecteConfiguracioPes } from "../../../../dao/abp/PostProjecteConfiguracioPes";
import { GetProjecteRubrica, PostProjecteRubrica, PutProjecteRubrica, DeleteProjecteRubrica } from "../../../../dao/abp/ProjecteRubrica";
import { GetProjecteRecuperacions, PostProjecteRecuperacio, PutProjecteRecuperacio, DeleteProjecteRecuperacio } from "../../../../dao/abp/ProjecteRecuperacio";

const ProjecteIdConfiguracio = (props: any) => {
    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const { id_projecte, id_grup, id_usuari } = useParams();
    const [grup, setGrups] = useState<any>({ items: [] });
    const [treeData, setTreeData] = useState<any>();
    const [data3, setData3] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [rubrica, setRubrica] = useState<any[]>([]);
    const [rubricaModal, setRubricaModal] = useState(false);
    const [rubricaEdit, setRubricaEdit] = useState<any>(null);
    const [rubricaForm] = Form.useForm();

    const [recuperacions, setRecuperacions] = useState<any[]>([]);
    const [selectedRecuperacio, setSelectedRecuperacio] = useState<number>(-1);
    const [recuperacioModal, setRecuperacioModal] = useState(false);
    const [recuperacioEdit, setRecuperacioEdit] = useState<any>(null);
    const [recuperacioForm] = Form.useForm();
    const { SHOW_PARENT } = TreeSelect;

    const [form] = Form.useForm();
    const [form2] = Form.useForm();

    function transformToTreeData(input: any) {
        console.log(input);
        return input.items.map((module: any, moduleIndex: number) => ({
            title: module.name,
            value: `${module.id}`,
            key: module.id,
            children: module.list.map((item: any, itemIndex: number) => ({
                title: `${item.desc}`,
                value: `${module.id}-${item.id}`,
                key: `${module.id}-${item.id}`,
            })),
        }));
    }

    useEffect(() => {
        if (isLoggedIn) {
            checkData();
            //console.log(props.data);
        }
    }, []);

    useEffect(() => {
        if (isLoggedIn) {
            loadRubricas();
        }
    }, [selectedRecuperacio]);

    async function loadRubricas() {
        setLoading(true);
        const rubricaData = await GetProjecteRubrica(id_projecte + "", selectedRecuperacio);
        if (rubricaData) setRubrica(rubricaData);
        setLoading(false);
    }

    async function checkData() {
        setLoading(true);
        const data = await GetProjecteId(id_projecte + "", 0);
        setBreadCrumb([{ nom: 'Home', nav: '/home' },
            { nom: 'avaluacio', nav: '/abp' },
            { nom: `${data.nom}`, nav: `/abp/projectes/${data.id}` }], true);

        const data2 = await GetAulaIdConfiguracio("0", 1);
        const formattedData = { items: data2 };

        const configData = await GetProjecteIdConfiguracio(id_projecte + "");
        if (configData) {
            setData3(configData.projecte_moduls);
            setTreeData(transformToTreeData(formattedData));

            // Populate form fields
            form.setFieldsValue({
                ras: configData.ras,
                escala_validacio: configData.escala_validacio
            });
        }



        const recupData = await GetProjecteRecuperacions(id_projecte + "");
        if (recupData) setRecuperacions(recupData);

        setLoading(false);
    }

    async function handleSaveRubrica(values: any) {
        setLoading(true);
        if (rubricaEdit) {
            await PutProjecteRubrica(rubricaEdit.id, { descripcio: values.descripcio, pes: values.pes });
        } else {
            await PostProjecteRubrica(id_projecte + "", {
                id_modul_ra: values.id_modul_ra,
                descripcio: values.descripcio,
                pes: values.pes,
                id_recuperacio: selectedRecuperacio === -1 ? undefined : selectedRecuperacio
            });
        }
        await loadRubricas();
        setRubricaModal(false);
        setRubricaEdit(null);
        rubricaForm.resetFields();
        setLoading(false);
    }

    async function handleDeleteRubrica(id: number) {
        setLoading(true);
        await DeleteProjecteRubrica(id);
        await loadRubricas();
        setLoading(false);
    }

    async function handleSaveRecuperacio(values: any) {
        setLoading(true);
        if (recuperacioEdit) {
            await PutProjecteRecuperacio(recuperacioEdit.id, {
                idModulRa: values.idModulRa,
                nom: values.nom,
                tipusRubrica: values.tipusRubrica,
                tipusCalcul: values.tipusCalcul,
                percentatgeNova: values.percentatgeNova || null,
                idRecuperacioPrevia: values.idRecuperacioPrevia || null
            });
        } else {
            await PostProjecteRecuperacio(id_projecte + "", {
                idModulRa: values.idModulRa,
                nom: values.nom,
                tipusRubrica: values.tipusRubrica,
                tipusCalcul: values.tipusCalcul,
                percentatgeNova: values.percentatgeNova || null,
                idRecuperacioPrevia: values.idRecuperacioPrevia || null
            });
        }
        const recupData = await GetProjecteRecuperacions(id_projecte + "");
        setRecuperacions(recupData);
        setRecuperacioModal(false);
        setRecuperacioEdit(null);
        recuperacioForm.resetFields();
        setLoading(false);
    }

    async function handleDeleteRecuperacio(id: number) {
        setLoading(true);
        await DeleteProjecteRecuperacio(id);
        const recupData = await GetProjecteRecuperacions(id_projecte + "");
        setRecuperacions(recupData);
        setSelectedRecuperacio(-1);
        setLoading(false);
    }

    async function submitData() {
        setLoading(true);
        //console.log("Form Values:", form.getFieldsValue()); // Verifica los valores del formulario al enviarlo
        await PostProjecteConfiguracio(id_projecte + "", form.getFieldsValue());
        checkData();
        setLoading(false);
    }

    const [value, setValue] = useState(['0-0-0']);

    const onChange = (newValue: string[]) => {
        //console.log('onChange ', newValue);
        setValue(newValue);
    };

    const tProps = {
        treeData,
        value,
        onChange,
        treeCheckable: true,
        showCheckedStrategy: SHOW_PARENT,
        placeholder: 'Please select',
        style: {
            width: '100%',
        },
    };

    function submitDataRas() {
        setLoading(true);
        //console.log("Form Values:", form2.getFieldsValue()); // Verifica los valores del formulario al enviarlo
        //await PostProjecteConfiguracio(id_projecte + "", form.getFieldsValue());
        //checkData();
        setLoading(false);
    }

    async function handlePesChange(value: React.FocusEvent<HTMLInputElement>, record: any) {

        setLoading(true);
        //console.log(id_projecte + " - " + record.id + " - " + value);
        await PostProjecteConfiguracioPes(id_projecte + "", record.id + "", value.target.value);
        const data3 = await GetProjecteIdConfiguracio(id_projecte + "");
        setData3(data3.projecte_moduls);

        setLoading(false);
    }

    const columns = [
        {
            title: 'Mòdul',
            dataIndex: 'modul',
            key: 'modul',
            width: 80,
            align: 'center' as const,
            render: (text: any, record: any) => (
                <Tag color={getRowColor(record.idmod)} style={{ fontWeight: 'bold' }}>{text}</Tag>
            )
        },
        {
            title: 'RA',
            dataIndex: 'ra',
            key: 'ra',
            width: 80,
            align: 'center' as const,
            render: (text: any, record: any) => (
                <Tag color={getRowColor(record.idmod)}>{`RA ${text}`}</Tag>
            )
        },
        {
            title: 'Descripció del Resultat d\'Aprenentatge',
            dataIndex: 'desc',
            key: 'desc',
            render: (text: any) => (
                <Typography.Text style={{ color: '#595959' }}>{text}</Typography.Text>
            )
        },
        {
            title: 'Pes (%)',
            dataIndex: 'pes',
            width: 120,
            key: 'pes',
            align: 'center' as const,
            render: (text: any, record: any, index: number) => (
                (user.tipus === "1" ?
                    <InputNumber
                        min={0}
                        max={100}
                        defaultValue={text || 0}
                        onBlur={(value) => handlePesChange(value, record)}
                        addonAfter="%"
                        style={{ width: '100%' }}
                    />
                    : <Tag color={getRowColor(record.idmod)} style={{ fontSize: '14px', padding: '4px 10px' }}>{`${text} %`}</Tag>)
            )
        }
    ];

    const getRowColor = (mod: any) => {
        const colors = [
            AvaluacioColors.colors.color1,
            AvaluacioColors.colors.color4,
            AvaluacioColors.colors.color2,
            AvaluacioColors.colors.color5,
            AvaluacioColors.colors.color3,
            AvaluacioColors.colors.color6
        ];
        return colors[mod % 6];
    };


    return (
        <div style={{ padding: '24px', maxWidth: 1600, margin: '0 auto' }}>
            <br />
            {/* Header */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 24,
                background: '#fff',
                padding: '16px 24px',
                borderRadius: 12,
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <div style={{
                        backgroundColor: AvaluacioColors.colors.color1,
                        padding: 10,
                        borderRadius: 10,
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <BiCog size={24} />
                    </div>
                    <div>
                        <h2 style={{ margin: 0, fontSize: 24, fontWeight: 600, color: '#1f1f1f' }}>Configuració del Projecte</h2>
                        <span style={{ color: '#8c8c8c' }}>Paràmetres generals i pesos</span>
                    </div>
                </div>

                <div style={{ display: 'flex', gap: 12 }}>
                    {!loading && (
                        <Button
                            icon={<BiRefresh size={18} />}
                            onClick={() => checkData()}
                            size="large"
                        >
                            Actualitzar
                        </Button>
                    )}
                </div>
            </div>

            <Row gutter={[24, 24]}>
                <Col xs={24} lg={8}>
                    <Card
                        title="Configuració General"
                        bordered={false}
                        style={{ borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.05)', height: '100%' }}
                    >
                        {user.tipus === "1" ? (
                            <Form
                                layout="vertical"
                                form={form}
                                disabled={loading}
                                onFinish={submitData}
                                initialValues={props.data}
                            >
                                <Form.Item label="Selecció de RAs" name={'ras'}>
                                    <TreeSelect {...tProps} />
                                </Form.Item>

                                <Form.Item label="Escala de Validació Máxima" name={'escala_validacio'} initialValue={5}>
                                    <Select options={[
                                        { label: 'De 1 a 3 (Malament / Bé / Molt Bé)', value: 3 },
                                        { label: 'De 1 a 5 (Molt Malament / Malament / Normal / Bé / Molt Bé)', value: 5 },
                                        { label: 'De 1 a 10', value: 10 }
                                    ]} />
                                </Form.Item>

                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    block
                                    loading={loading}
                                    style={{ backgroundColor: AvaluacioColors.colors.color4 }}
                                >
                                    Actualitzar RAs
                                </Button>
                            </Form>
                        ) : (
                            <p>No tens permisos per editar la configuració general.</p>
                        )}
                    </Card>
                </Col>

                <Col xs={24} lg={16}>
                    <Card
                        title="Pesos dels Mòduls"
                        bordered={false}
                        style={{ borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}
                        bodyStyle={{ padding: 0 }}
                    >
                        <Table
                            columns={columns}
                            dataSource={data3?.sort((a: any, b: any) => a.modul.localeCompare(b.modul))}
                            pagination={false}
                            loading={loading}
                            size="middle"
                            rowClassName={(record) => `row-${record.idmod}`}
                        />
                    </Card>
                </Col>
            </Row>

            {/* ─── Rúbrica ─────────────────────────────── */}
            {user.tipus === "1" && (
                <Card
                    title="Rúbrica per RA"
                    bordered={false}
                    style={{ borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.05)', marginTop: 24 }}
                    extra={
                        <div style={{ display: 'flex', gap: 10 }}>
                            <Select
                                value={selectedRecuperacio}
                                onChange={setSelectedRecuperacio}
                                style={{ width: 220 }}
                                options={[
                                    { label: 'Avaluació Ordinària', value: -1 },
                                    ...recuperacions.map(r => ({
                                        label: `Recuperació: ${r.nom}`,
                                        value: r.id
                                    }))
                                ]}
                            />
                            {selectedRecuperacio !== -1 && (
                                <>
                                    <Button icon={<BiEdit />} onClick={() => {
                                        const recup = recuperacions.find(r => r.id === selectedRecuperacio);
                                        if (recup) {
                                            setRecuperacioEdit(recup);
                                            recuperacioForm.setFieldsValue({
                                                nom: recup.nom,
                                                tipusRubrica: recup.tipusRubrica !== undefined ? recup.tipusRubrica : recup.tipus_rubrica,
                                                tipusCalcul: recup.tipusCalcul !== undefined ? recup.tipusCalcul : recup.tipus_calcul,
                                                percentatgeNova: recup.percentatgeNova !== undefined ? recup.percentatgeNova : recup.percentatge_nova,
                                                idRecuperacioPrevia: recup.idRecuperacioPrevia !== undefined ? recup.idRecuperacioPrevia : recup.id_recuperacio_previa
                                            });
                                            setRecuperacioModal(true);
                                        }
                                    }} />
                                    <Popconfirm title="Eliminar aquesta recuperació?" onConfirm={() => handleDeleteRecuperacio(selectedRecuperacio)} okText="Sí" cancelText="No">
                                        <Button danger icon={<BiTrash />} />
                                    </Popconfirm>
                                </>
                            )}
                            <Button
                                type="primary"
                                icon={<BiPlus />}
                                style={{ backgroundColor: AvaluacioColors.colors.color5 }}
                                onClick={() => { setRecuperacioEdit(null); recuperacioForm.resetFields(); setRecuperacioModal(true); }}
                            >
                                Nova Recuperació
                            </Button>
                            <Button
                                type="primary"
                                icon={<BiPlus />}
                                style={{ backgroundColor: AvaluacioColors.colors.color2 }}
                                onClick={() => { setRubricaEdit(null); rubricaForm.resetFields(); setRubricaModal(true); }}
                            >
                                Nou Aspecte
                            </Button>
                        </div>
                    }
                >
                    <Table
                        loading={loading}
                        size="middle"
                        pagination={false}
                        dataSource={rubrica}
                        rowKey="id"
                        columns={[
                            {
                                title: 'Mòdul',
                                dataIndex: 'modul_nom',
                                key: 'modul_nom',
                                width: 100,
                                render: (e: any, r: any) => <Tag color={getRowColor(r.id_modul_ra % 6)} style={{ fontWeight: 'bold' }}>{e}</Tag>
                            },
                            {
                                title: 'RA',
                                dataIndex: 'ra_nom',
                                key: 'ra_nom',
                                render: (e: any) => <Typography.Text strong>{e}</Typography.Text>
                            },
                            {
                                title: 'Aspecte a Avaluar',
                                dataIndex: 'descripcio',
                                key: 'descripcio',
                            },
                            {
                                title: 'Pes (%)',
                                dataIndex: 'pes',
                                key: 'pes',
                                width: 90,
                                align: 'center' as const,
                                render: (e: any) => <Tag color="blue">{e}%</Tag>
                            },
                            {
                                title: '',
                                key: 'actions',
                                width: 90,
                                align: 'center' as const,
                                render: (_: any, record: any) => (
                                    <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                                        <Tooltip title="Editar">
                                            <Button size="small" icon={<BiEdit />} onClick={() => {
                                                setRubricaEdit(record);
                                                rubricaForm.setFieldsValue({ descripcio: record.descripcio, pes: record.pes, id_modul_ra: record.id_modul_ra });
                                                setRubricaModal(true);
                                            }} />
                                        </Tooltip>
                                        <Popconfirm title="Eliminar aquest aspecte?" onConfirm={() => handleDeleteRubrica(record.id)} okText="Sí" cancelText="No">
                                            <Button size="small" danger icon={<BiTrash />} />
                                        </Popconfirm>
                                    </div>
                                )
                            }
                        ]}
                    />
                </Card>
            )}

            <Modal
                title={rubricaEdit ? "Editar Aspecte" : "Nou Aspecte de Rúbrica"}
                open={rubricaModal}
                onCancel={() => { setRubricaModal(false); setRubricaEdit(null); rubricaForm.resetFields(); }}
                onOk={() => rubricaForm.submit()}
                okText="Guardar"
                cancelText="Cancel·lar"
                confirmLoading={loading}
            >
                <Form form={rubricaForm} layout="vertical" onFinish={handleSaveRubrica}>
                    {!rubricaEdit && (
                        <Form.Item label="RA" name="id_modul_ra" rules={[{ required: true, message: 'Selecciona un RA' }]}>
                            <Select
                                showSearch
                                placeholder="Seleccionar RA..."
                                filterOption={(input, option) =>
                                    (option?.label as string || '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={data3?.map((m: any) => ({
                                    value: m.id_modul_ra,
                                    label: `${m.modul} · RA${m.ra} - ${m.desc}`
                                }))}
                            />
                        </Form.Item>
                    )}
                    {rubricaEdit && (
                        <Form.Item label="RA">
                            <Typography.Text strong>{rubricaEdit.ra_nom}</Typography.Text>
                        </Form.Item>
                    )}
                    <Form.Item label="Descripció de l'aspecte" name="descripcio" rules={[{ required: true }]}>
                        <Input placeholder="Ex: Qualitat del codi, Documentació, Funcionament..." />
                    </Form.Item>
                    <Form.Item label="Pes dins el RA (%)" name="pes" rules={[{ required: true }]}>
                        <InputNumber min={0} max={100} addonAfter="%" style={{ width: '100%' }} />
                    </Form.Item>
                </Form>
            </Modal>


            <Modal
                title={recuperacioEdit ? "Editar Recuperació" : "Nova Recuperació"}
                open={recuperacioModal}
                onCancel={() => { setRecuperacioModal(false); setRecuperacioEdit(null); recuperacioForm.resetFields(); }}
                onOk={() => recuperacioForm.submit()}
                okText={recuperacioEdit ? "Guardar" : "Crear"}
                cancelText="Cancel·lar"
                confirmLoading={loading}
            >
                <Form form={recuperacioForm} layout="vertical" onFinish={handleSaveRecuperacio}>

                    <Form.Item label="Nom de la Recuperació" name="nom" rules={[{ required: true }]}>
                        <Input placeholder="Ex: Recuperació 1" />
                    </Form.Item>
                    <Form.Item label="Tipus de Rúbrica" name="tipusRubrica" initialValue={0}>
                        <Select options={[
                            { label: 'Fer servir els mateixos camps que l\'avaluació ordinària', value: 0 },
                            { label: 'Fer servir camps diferents', value: 1 },
                            { label: 'Sense aspectes (avaluació directa del RA)', value: 2 }
                        ]} />
                    </Form.Item>
                    <Form.Item label="Tipus de Càlcul" name="tipusCalcul" initialValue={1}>
                        <Select options={[
                            { label: 'Fer mitjana amb l\'anterior', value: 0 },
                            { label: 'Reemplaçar la nota (només RAs suspesos)', value: 1 },
                            { label: 'Nota numèrica directa (Ignora tasques, només avalua validació)', value: 2 }
                        ]} />
                    </Form.Item>

                    <Form.Item
                        noStyle
                        shouldUpdate={(prevValues, currentValues) => prevValues.tipusCalcul !== currentValues.tipusCalcul}
                    >
                        {({ getFieldValue }) =>
                            getFieldValue('tipusCalcul') === 0 ? (
                                <Form.Item label="Percentatge de la nova nota (%)" name="percentatgeNova" initialValue={50} rules={[{ required: true }]}>
                                    <InputNumber min={1} max={100} addonAfter="%" style={{ width: '100%' }} />
                                </Form.Item>
                            ) : null
                        }
                    </Form.Item>

                    <Form.Item
                        noStyle
                        shouldUpdate={(prevValues, currentValues) => prevValues.tipusCalcul !== currentValues.tipusCalcul}
                    >
                        {({ getFieldValue }) =>
                            getFieldValue('tipusCalcul') === 0 ? (
                                <Form.Item label="Amb quina avaluació fa mitjana?" name="idRecuperacioPrevia">
                                    <Select allowClear placeholder="Ordinària (Per defecte)" options={recuperacions.map((r: any) => ({
                                        label: r.nom,
                                        value: r.id
                                    }))} />
                                </Form.Item>
                            ) : null
                        }
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );


};

export default ProjecteIdConfiguracio;
